import React from "react";
import { Box, Heading, Text, Grid, GridItem, Center, Image, VStack } from "@chakra-ui/react";
import BehaviouralFounder from "../../assets/behavioural-founder.png";
import Paw from "../../assets/paw.png";
import { lightGreen, primaryGreen } from "../../constants";

export const BehaviouralLead = () => {
  return (
    <Box bg="white" as="section" py={{ base: 12, md: 20 }} position="relative">
      <Box maxW="7xl" mx="auto" px={6}>
        <Grid templateColumns={{ base: "1fr", md: "0.7fr 1fr" }} gap={20}>
          <GridItem>
            <VStack align="flex-start" justify="center" spacing={6}>
              <Heading as="h2" size="lg" color={lightGreen} fontFamily="'Baloo 2', sans-serif">
                Sarah Squire
              </Heading>
              <Heading as="h2" size="lg" color={primaryGreen} fontFamily="'Baloo 2', sans-serif">
                Lead Behaviourist
              </Heading>
              <Text color="gray.700" fontFamily="'Baloo 2', sans-serif" lineHeight={1.8}>
                Sarah Squire is a highly experienced and dedicated dog behaviourist with over 20 years of experience in the field providing behavioural assessments, one-to-one training, obedience work, puppy and older dog socialisation groups. Sarah graduated with honours in Psychology and then went on to complete a post graduate certificate in education and for many years worked as a special needs teacher, supporting children with learning and behavioural difficulties as well as working
                extensively with the dog charity, Every Paw Matters as their behavioural expert.{" "}
              </Text>
            </VStack>
          </GridItem>
          <GridItem>
            <Center h="100%">
              <Image h="auto" w="70%" borderRadius="lg" src={BehaviouralFounder} alt="Dog Field" />
            </Center>
          </GridItem>
        </Grid>
        <Image src={Paw} alt="Paw" position="absolute" bottom="0" right="0" w="20%" zIndex={9} />
      </Box>
    </Box>
  );
};
